// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#header[data-v-3f8a4a33] {\n  float: right;\n}\n#title[data-v-3f8a4a33] {\n  padding: 10px\n}\n.alert-margin[data-v-3f8a4a33]{\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.search-solid[data-v-3f8a4a33]{\n  cursor: pointer;\n  height: 18px;\n  width: 18px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
